import { locales } from 'constants/locales'

export const oneTrustOnClick = () => {
  const oneTrust = window.OneTrust
  if (oneTrust && typeof oneTrust.ToggleInfoDisplay === 'function')
    oneTrust.ToggleInfoDisplay()
}

export const hasOneTrustFooter = (country: string, brand: string) => {
  const regionConfig = locales[country as keyof typeof locales]
  return regionConfig.ONE_TRUST_FOOTER?.[brand] === true
}

export const personalInfoDisclaimer = (country: string, brand: string) => {
  const regionConfig = locales[country as keyof typeof locales]
  return regionConfig.DONOT_SELL_PERSONAL_INFO?.[brand]
}
